import { render, staticRenderFns } from "./TablaPlantillas.vue?vue&type=template&id=cbd80992"
import script from "./TablaPlantillas.vue?vue&type=script&lang=js"
export * from "./TablaPlantillas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports